import Model from './Model';
import Vue from 'vue';

export default class Profile extends Model {
    id;
    name;
    first_name;
    last_name;

    static apiPath() {
        return 'account';
    }

    /**
     * Get a specific document from the api
     * @param id
     * @returns {Promise}
     */
    static evaluationProfile(id, diploma_id, work_process_id, evaluation_id) {
        return Vue.axios.get(this.apiPath() + '/' + id + '/diplomas/' + diploma_id + '/work-processes/' + work_process_id + '/evaluations/' + evaluation_id + '/sharing')
            .then(resp => {
                let data = resp.data;

                if (data) {
                    return this.fromJson(data);
                } else {
                    //reject
                }
            }).catch(({ status, errors }) => {
                throw { status, errors };
            });
    }

    /**
     * Get a specific document from the api
     * @param id
     * @returns {Promise}
     */
    static workProcesses(id, page = 1) {
        return Vue.axios.get(this.apiPath() + '/' + id + '/work-processes?page=' + page).then(resp => {
            let data = resp.data;

            if (data) {
                return this.fromJson(data);
            } else {
                //reject
            }
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    /**
     * Get a specific document from the api
     * @param id
     * @returns {Promise}
     */
    static evaluations(id, page = 1, filter = 'all') {
        return Vue.axios.get(`${this.apiPath()}/${id}/evaluations?filter=${filter}&page=${page}`).then(resp => {
            let data = resp.data;

            if (data) {
                return this.fromJson(data);
            } else {
                //reject
            }
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    /**
     * Get a specific document from the api
     * @param id
     * @returns {Promise}
     */
    static chart(user_id, diploma_id) {
        return Vue.axios.get(`${this.apiPath()}/${user_id}/diplomas/${diploma_id}/chart`)
            .then(resp => {
                let data = resp.data;
                if (data) {
                    return data;
                } else {
                    //reject
                }
            }).catch(({ status, errors }) => {
                throw { status, errors };
            });
    }

    /**
     * Get a specific document from the api
     * @param id
     * @returns {Promise}
     */
    static diploma(user_id, diploma_id) {
        return Vue.axios.get(`${this.apiPath()}/${user_id}/diplomas`).then(resp => {
            let data = resp.data;

            if (data) {
                return this.fromJson(data);
            } else {
                //reject
            }
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    toJson() {
        // When submitting an change, we need to send id's for the relations instead of the values themselves.
        const dtoIds = {
            id: this.id
        };

        return { ...this, ...dtoIds };
    }
}



// WEBPACK FOOTER //
// ./src/models/Profile.js